import { InvoiceTableRoot } from "../../../Invoices/InvoiceTableRoot";

export function ContactInvoices() {
  return (
    <InvoiceTableRoot
      context={ `contact` }
    />
  );
}
